import React, {Component} from 'react';
import EventFormat from "./event_format";
import Exhibitors from "./exhibitors";
import Attendees from "./attendees";
import Features from "./key_features";
import EventTimeFrame from "./event_timeline";
import EventView from "./event_view";
import {Col, Container, Row} from "react-bootstrap";
import EventType from "./event_type";
import {Field, Form, Formik} from 'formik';
import axios from 'axios';
import {attendees, eventFormats, eventTimeFrame, eventType, eventView, exhibitors, features} from "./form_values";
// import { buildSummaryInfo } from './summaryHelper';

// manually forwarding for now
// async function sendSubmitEmail(formValues) {
// 	console.log('sending submission confirmation email', formValues);
// 	const { email, ...rest } = formValues;
// 	const options = buildSummaryInfo(rest);
// 	const payload = {
// 		email,
// 		templateName: 'submit',
// 		options,
// 	}
// 	const emailSubmitEndpoint = process.env.EMAIL_SUBMIT_ENDPOINT
// 		|| 'https://d0pnlezo71.execute-api.eu-west-1.amazonaws.com/platform-match-send-email';
// 	await fetch(emailSubmitEndpoint, {
// 		method: 'POST',
// 		headers: {
// 			'Content-Type': 'application/json'
// 		},
// 		body: JSON.stringify(payload)
// 	});
// }

export default class MainForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: false,
			errorMsg: "ALL FIELDS AND A VALID EMAIL ADDRESS ARE REQUIRED.",
			loading: false,
			compressedFeatures: [],
			unique_key: ''
		}

		this.compressFeatures = this.compressFeatures.bind(this);
	}

	compressFeatures = (setFieldValue, prevValue) => ({ target }) => {
		const feature = features.find(feature => feature.value === target.value);
		const compressedFeatures = target.checked === true
			? [...this.state.compressedFeatures, feature]
			: this.state.compressedFeatures.filter(f => f.value !== target.value);

		this.setState({ compressedFeatures });

		if (target.checked === false) {
			const {[target.value]: remove, ...newValue } = prevValue;
			setFieldValue('key_features', newValue);
		}
	}

	validate(values) {
		let error = false
		if (values.event_format === []) {
			// console.log(1)
			error = true
		}
		if (values.event_type === "") {
			// console.log(2,values.event_type)
			error = true
		}
		if (values.attendees_number === 0) {
			// console.log(3)
			error = true
		}
		if (values.exhibitors === 0) {
			// console.log(4,values.exhibitors)
			error = true
		}
		if (values.key_features === {}) {
			// console.log(5)
			error = true
		}
		if (values.time_frame === {}) {
			// console.log(6)
			error = true
		}
		if (values.event_view === {}) {
			// console.log(7)
			error = true
		}
		if (values.email === "") {
			// console.log(8)
			error = true
		}
		// we need a valid email address
		let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!re.test(values.email)) {
			// console.log(9)
			error = true
		}

		return error
	}

	render() {
		const error = this.state.error
		let errorHTML
		if (error) {
			errorHTML =
				<Row><Col md={{size: 6, offset: 6}}><p className="question-header error-msg">{this.state.errorMsg}</p>
				</Col></Row>;
		}
		let loading
		if (this.state.loading) {
			loading = <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
		}

		return (
			<Container>
				<Formik
					initialValues={{
						attendees_number: 0,
						event_format: [],
						event_view: "",
						event_type: "",
						exhibitors: 0,
						email: "",
						time_frame: {},
						key_features: {},
					}}
					onSubmit={async (values) => {
						if (this.validate(values)) {
							this.setState({"error": true})
							return
						} else {
							this.setState({
								"error": false
							})
						}

						this.setState({loading: true})
						const api = process.env.REACT_APP_API_ENDPOINT;
						const data = JSON.stringify(values)
						const headers = {
							'Content-Type': 'application/json',
						}
						axios.post(api, data, {
								headers: headers,
								timeout: 10000
							})
							.then((response) => {
								this.setState({
									email: "",
									loading: false
								})
								document.getElementById("platform-match").reset();
								window.scrollTo(0, 0)
								const reset_val = Date.now();
								this.setState({unique_key: reset_val});
								window.location.href = 'https://londonfilmed.com/platform-match-submission/';
							})
							.catch((error) => {
								this.setState({errorMsg: "ERROR, PLEASE CONTACT HELLO@LONDONFILMED.COM", error: true})
								this.setState({loading: false})
								this.setState({compressedFeatures: []})
								console.log(error)
							})
					}}
				>
					{({values, setFieldValue, setFieldTouched}) => (
						<Form id="platform-match" key={this.state.unique_key}>
							<Row>
								<EventFormat
									data={eventFormats}
									onChange={setFieldValue}
									onBlur={setFieldTouched}
								/>
								<EventType
									onChange={setFieldValue}
									onBlur={setFieldTouched}
									data={eventType}
								/>
							</Row>

							<Exhibitors
								data={exhibitors}
								onChange={setFieldValue}
							/>

							<Attendees
								data={attendees}
								onChange={setFieldValue}
							/>

							<Features
								values={values}
								onChange={setFieldValue}
								onBlur={setFieldTouched}
								featureCompression={this.compressFeatures(setFieldValue, values.key_features)}
								data={features}
								compressedFeatures={this.state.compressedFeatures}
							/>

							<EventTimeFrame
								data={eventTimeFrame}
								values={values}
								onChange={setFieldValue}
							/>

							<EventView
								onChange={setFieldValue}
								data={eventView}
								values={values}
							/>
							<Row>
								<Col>
									<h4 className="ui centered question-header text-center">Enter your email and start
										the
										matching process</h4>
								</Col>
							</Row>
							{errorHTML}
							<Row>
								<Col sm="8">
									<Field id="email" name="email" type="text" className="email"
										   placeholder="example@domain.com"
									/>
								</Col>
								<Col>
									<button type="submit" className="checkbox-label submit">
										{loading}
										Submit
									</button>
								</Col>
							</Row>
							<Row>
								<Col>
									<span className="ui centered text-center">
										Please refer to our Privacy Policy <a href="https://londonfilmed.com/privacy/">here</a> for more information
									</span>
								</Col>
							</Row>
						</Form>
					)}
				</Formik>
			</Container>
		)
	}
}
